import { DefaultService } from "@/api/SolarCloudApi";
import { QueryConfig } from "@/lib/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export default function getOwnerDisbursementsQueryOptions() {
  return queryOptions({
    queryKey: ["ownerDisbursements"],
    queryFn: getOwnerDisbursements,
    retry: false,
    staleTime: 1000 * 60 * 60,
  });
}

async function getOwnerDisbursements() {
  const response = await DefaultService.ownerDisbursementsGet();
  return response.collection ?? [];
}

type UseOwnerDisbursementsOptions = {
  queryConfig?: QueryConfig<typeof getOwnerDisbursementsQueryOptions>;
};

export function useOwnerDisbursements({
  queryConfig,
}: UseOwnerDisbursementsOptions = {}) {
  return useQuery({
    ...getOwnerDisbursementsQueryOptions(),
    ...queryConfig,
  });
}
